export default __webpack_public_path__ + "static/media/asset.d1cde238.svg";